export const DEFAULT_SAFE_AREAS = {
    'title-safe': { top: 0.1, right: 0.1, bottom: 0.1, left: 0.1 },
    'action-safe': { top: 0.05, right: 0.05, bottom: 0.05, left: 0.05 },
    'subtitle-safe': { top: 0.8, right: 0.1, bottom: 0.08, left: 0.1 },
    'platform-safe': { top: 0.12, right: 0.12, bottom: 0.16, left: 0.12 },
};
export function safeAreaToPixels(safe, size) {
    return {
        top: safe.top * size.height,
        right: safe.right * size.width,
        bottom: safe.bottom * size.height,
        left: safe.left * size.width,
    };
}
export function safeAreaToRect(safe, size) {
    return {
        x: safe.left * size.width,
        y: safe.top * size.height,
        width: (1 - safe.left - safe.right) * size.width,
        height: (1 - safe.top - safe.bottom) * size.height,
    };
}
export function safeAreaCss(safe, size, _label, color) {
    const px = safeAreaToPixels(safe, size);
    return `position:absolute; top:${px.top}px; right:${px.right}px; bottom:${px.bottom}px; left:${px.left}px; border:1px dashed ${color}; pointer-events:none; z-index:9999;`;
}
export function isWithinSafeArea(normalizedX, normalizedY, safe) {
    return (normalizedX >= safe.left &&
        normalizedX <= 1 - safe.right &&
        normalizedY >= safe.top &&
        normalizedY <= 1 - safe.bottom);
}
export function validateSafeAreas(safe) {
    return (safe.top >= 0 &&
        safe.right >= 0 &&
        safe.bottom >= 0 &&
        safe.left >= 0 &&
        safe.top + safe.bottom <= 1 &&
        safe.left + safe.right <= 1);
}
//# sourceMappingURL=safe-areas.js.map